// extracted by mini-css-extract-plugin
export var actions = "_q0-4";
export var item = "_q0-1";
export var price = "_q0-3";
export var quantity = "_q0-2";
export var table = "_q0-0";